import { AdvancedProperty } from './Property'
import { FieldMapping } from './Templates'

export interface ExportList {
  properties: AdvancedProperty[]
  focused: boolean
  selectedIndex: number
}

export interface ProductExportTemplate {
  name: string
  useNumericValues?: boolean
  showSpecificCulturalFields?: boolean
  mappings: FieldMapping[]
  id: string
}

export interface ProductExportTemplateInput extends Omit<ProductExportTemplate, 'id'> {}

export const ExportTypes = ['productData', 'eanLabels', 'productSheet'] as const
export type ExportType = (typeof ExportTypes)[number]
